import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputErrorsComponent } from '@app/shared/components/input-errors/input-errors.component';
import { SplitButtonComponent } from './components/split-button/split-button.component';
import {
  MatButtonModule,
  MatButtonToggleModule,
  MatIconModule,
  MatMenuModule,
  MatRippleModule,
  MatTooltipModule,
} from '@angular/material';
import { SplitButtonActionDirective } from './directives/split-button-action/split-button-action.directive';
import { NgxMatEsign360Module } from 'ngx-mat-esign360';
import { ButtonToggleGroupComponent } from './components/button-toggle-group/button-toggle-group.component';
import { ButtonFileInputComponent } from './components/button-file-input/button-file-input.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    InputErrorsComponent,
    SplitButtonComponent,
    SplitButtonActionDirective,
    ButtonToggleGroupComponent,
    ButtonFileInputComponent,
  ],
  imports: [
    CommonModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatRippleModule,
    MatTooltipModule,
    NgxMatEsign360Module,
    TranslateModule,
  ],
  exports: [
    CommonModule,
    InputErrorsComponent,
    SplitButtonComponent,
    SplitButtonActionDirective,
    ButtonToggleGroupComponent,
    ButtonFileInputComponent,
    TranslateModule,
    MatMenuModule,
  ],
})
export class SharedModule {}
